// src/reducers/delhiReducers.js
import {
    GET_DELHI_RECORDS_REQUEST,
    GET_DELHI_RECORDS_SUCCESS,
    GET_DELHI_RECORDS_FAIL,
    GET_DELHI_RECORDS_RESET,
    CREATE_DELHI_RECORD_REQUEST,
    CREATE_DELHI_RECORD_SUCCESS,
    CREATE_DELHI_RECORD_FAIL,
    CREATE_DELHI_RECORD_RESET,
    UPDATE_DELHI_RECORD_REQUEST,
    UPDATE_DELHI_RECORD_SUCCESS,
    UPDATE_DELHI_RECORD_FAIL,
    UPDATE_DELHI_RECORD_RESET,
    DELETE_DELHI_RECORD_REQUEST,
    DELETE_DELHI_RECORD_SUCCESS,
    DELETE_DELHI_RECORD_FAIL,
    DELETE_DELHI_RECORD_RESET,
    BULK_DELETE_DELHI_RECORDS_REQUEST,
    BULK_DELETE_DELHI_RECORDS_SUCCESS,
    BULK_DELETE_DELHI_RECORDS_FAIL,
    BULK_DELETE_DELHI_RECORDS_RESET,
    IMPORT_DELHI_RECORDS_REQUEST,
    IMPORT_DELHI_RECORDS_SUCCESS,
    IMPORT_DELHI_RECORDS_FAIL,
    IMPORT_DELHI_RECORDS_RESET,
    EXPORT_DELHI_RECORDS_REQUEST,
    EXPORT_DELHI_RECORDS_SUCCESS,
    EXPORT_DELHI_RECORDS_FAIL,
    EXPORT_DELHI_RECORDS_RESET,
    UPDATE_DELHI_CELL_REQUEST,
    UPDATE_DELHI_CELL_SUCCESS,
    UPDATE_DELHI_CELL_FAIL,
    UPDATE_DELHI_CELL_RESET,
} from '../constants/delhiConstants';

// Get Delhi Records Reducer
export const getDelhiRecordsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_DELHI_RECORDS_REQUEST:
            return { loadingGetDelhiRecords: true };
        case GET_DELHI_RECORDS_SUCCESS:
            return {
                loadingGetDelhiRecords: false,
                getDelhiRecordsData: action.payload,
            };
        case GET_DELHI_RECORDS_FAIL:
            return {
                loadingGetDelhiRecords: false,
                errorGetDelhiRecords: action.payload,
            };
        case GET_DELHI_RECORDS_RESET:
            return {};
        default:
            return state;
    }
};

// Create Delhi Record Reducer
export const createDelhiRecordReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_DELHI_RECORD_REQUEST:
            return { loading: true };
        case CREATE_DELHI_RECORD_SUCCESS:
            return { loading: false, success: true, record: action.payload };
        case CREATE_DELHI_RECORD_FAIL:
            return { loading: false, error: action.payload };
        case CREATE_DELHI_RECORD_RESET:
            return {};
        default:
            return state;
    }
};

// Update Delhi Record Reducer
export const updateDelhiRecordReducer = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_DELHI_RECORD_REQUEST:
            return { loadingUpdateDelhiRecord: true };
        case UPDATE_DELHI_RECORD_SUCCESS:
            return {
                loadingUpdateDelhiRecord: false,
                updateDelhiRecordData: action.payload,
            };
        case UPDATE_DELHI_RECORD_FAIL:
            return {
                loadingUpdateDelhiRecord: false,
                errorUpdateDelhiRecord: action.payload,
            };
        case UPDATE_DELHI_RECORD_RESET:
            return {};
        default:
            return state;
    }
};

// Update Delhi Cell Reducer (for inline editing)
export const updateDelhiCellReducer = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_DELHI_CELL_REQUEST:
            return { loading: true };
        case UPDATE_DELHI_CELL_SUCCESS:
            return { loading: false, success: true, updatedCell: action.payload };
        case UPDATE_DELHI_CELL_FAIL:
            return { loading: false, error: action.payload };
        case UPDATE_DELHI_CELL_RESET:
            return {};
        default:
            return state;
    }
};

// Delete Delhi Record Reducer
export const deleteDelhiRecordReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_DELHI_RECORD_REQUEST:
            return { loading: true };
        case DELETE_DELHI_RECORD_SUCCESS:
            return { loading: false, success: true };
        case DELETE_DELHI_RECORD_FAIL:
            return { loading: false, error: action.payload };
        case DELETE_DELHI_RECORD_RESET:
            return {};
        default:
            return state;
    }
};

// Bulk Delete Delhi Records Reducer
export const bulkDeleteDelhiRecordsReducer = (state = {}, action) => {
    switch (action.type) {
        case BULK_DELETE_DELHI_RECORDS_REQUEST:
            return { loadingBulkDeleteDelhiRecords: true };
        case BULK_DELETE_DELHI_RECORDS_SUCCESS:
            return {
                loadingBulkDeleteDelhiRecords: false,
                bulkDeleteDelhiRecordsData: action.payload,
            };
        case BULK_DELETE_DELHI_RECORDS_FAIL:
            return {
                loadingBulkDeleteDelhiRecords: false,
                errorBulkDeleteDelhiRecords: action.payload,
            };
        case BULK_DELETE_DELHI_RECORDS_RESET:
            return {};
        default:
            return state;
    }
};

// Import Delhi Records Reducer
export const importDelhiRecordsReducer = (state = {}, action) => {
    switch (action.type) {
        case IMPORT_DELHI_RECORDS_REQUEST:
            return { loadingImportDelhiRecords: true };
        case IMPORT_DELHI_RECORDS_SUCCESS:
            return {
                loadingImportDelhiRecords: false,
                importDelhiRecordsData: action.payload,
            };
        case IMPORT_DELHI_RECORDS_FAIL:
            return {
                loadingImportDelhiRecords: false,
                errorImportDelhiRecords: action.payload,
            };
        case IMPORT_DELHI_RECORDS_RESET:
            return {};
        default:
            return state;
    }
};

// Export Delhi Records Reducer
export const exportDelhiRecordsReducer = (state = {}, action) => {
    switch (action.type) {
        case EXPORT_DELHI_RECORDS_REQUEST:
            return { loadingExportDelhiRecords: true };
        case EXPORT_DELHI_RECORDS_SUCCESS:
            return {
                loadingExportDelhiRecords: false,
                exportDelhiRecordsData: action.payload,
            };
        case EXPORT_DELHI_RECORDS_FAIL:
            return {
                loadingExportDelhiRecords: false,
                errorExportDelhiRecords: action.payload,
            };
        case EXPORT_DELHI_RECORDS_RESET:
            return {};
        default:
            return state;
    }
};